<template>
  <div class="animated fadeIn col-md-12">
    <Search
      :allowFields="$lang.searchContentPerson"
      :allowCollapse="false"
      :url="url"
      :hiddenFields="hiddenFields"
      :title="title"
      config="person_content"
      addModalSize="xl"
      removeModalSize="xl"
      :visibleSearch="true"
      :visibleSettings="true"
      :visibleExport="true"
      :visibleFilters="true"
      :visibleViewCount="true"
      :visibleAdd="false"
      :allowEdit="false"
      :dynamicButtons="buttonsContent"
      ref="personContentSearch"
      @getOther="getOtherData"
    />
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="view_edit_content"
      size="xl"
      ok-only
      hide-header
    >
      <EditPersonContent
        :pesronContentId="pesronContentId"
        @closeModal="closeModal"
        @updateItem="updateItem"
      />
      <template v-slot:modal-footer>
        <b-button class="ml-2" size="md" variant="danger" @click="closeModal">
          {{ $lang.close }}
          <i class="fa fa-ban"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import Search from "@/components/base/search";
import EditPersonContent from "./editPersonContent";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export default {
  name: "person-content-search",
  components: {
    Search,
    EditPersonContent,
  },
  data() {
    return {
      personCode: this.$route.params.code,
      hiddenFields: [
        "description",
        "created_by",
        "created_at.jalali",
        "reference",
      ],
      view_edit_content: false,
      pesronContentId: null,
      buttonsContent: [
        {
          id: "0",
          name: "edit",
          click: this.editPersonContent,
        },
        {
          id: "2",
          name: "view",
          click: this.editPersonContent,
        },
      ],
      otherData: null,
    };
  },
  computed: {
    url() {
      return this.personCode
        ? generateApiUrl(
            ["task", "azmoon_execute_person_content"],
            [this.personCode]
          )
        : generateApiUrl(["resources", "person_content"]);
    },
    title() {
      const fullName = pathOr("", ["full_name"], this.otherData);
      return this.personCode
        ? `محتوا ${fullName}`
        : this.$lang.person_content_title;
    },
  },
  methods: {
    pathOr,
    updateItem() {
      this.$refs.personContentSearch.getItems();
    },
    editPersonContent(item) {
      this.view_edit_content = true;
      this.pesronContentId = pathOr(null, ["id"], item);
    },
    closeModal() {
      this.view_edit_content = false;
    },
    getOtherData(data) {
      this.otherData = data;
    },
  },
};
</script>
